import { get, isEmpty } from 'lodash-es';
import { getQuery } from 'client/utils/location';
import { getPriceString } from 'site-modules/shared/utils/price-utils';

export function getDisplayedStyleId({ location, styles, tcoStylesData }) {
  const firstStyle =
    !!styles && !!tcoStylesData && (styles.find(({ id }) => !!get(tcoStylesData, `["${id}"].totalCash`)) || styles[0]);

  return parseInt(getQuery(location).style || get(firstStyle, 'id'), 10);
}

export function isTcoDataAvailable({ tcoStylesData, styleId }) {
  const tco = get(tcoStylesData, `[${styleId}]`, {});
  return !isEmpty(tco.years) && !!get(tco, 'total.tcoPrice');
}

export function getTcoPriceStrings({ tcoStylesData, styleId }) {
  return {
    totalTcoPrice: getPriceString(get(tcoStylesData, `[${styleId}].total.tcoPrice`) || 0),
    totalCashPrice: getPriceString(get(tcoStylesData, `[${styleId}].totalCash`) || 0),
  };
}
